export const authTypes = {
   AUTH_LOGIN: 'AUTH_LOGIN',
   AUTH_LOGOUT: 'AUTH_LOGOUT',
   IS_REQUEST_ACCESS_TOKEN: 'IS_REQUEST_ACCESS_TOKEN',

   VERIFY_AUTH: 'VERIFY_AUTH'
}